import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Context = React.createContext([{}, () => {}]);

const AppProvider = props => {
  const [state, setState] = useState({});
  return <Context.Provider value={[state, setState]}>{props.children}</Context.Provider>;
};

AppProvider.propTypes = {
  children: PropTypes.node
};

export { Context, AppProvider };
